/*******************************************************************************
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2016, 2024. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 *******************************************************************************/
'use strict';

/*
 * The categories to group templates by on the Create a Toolchain page.
 * Templates are grouped by adding the specified tag, and the key refers to the
 * message key in the common.properties file for the category label. The categories
 * are shown in the specified order.
 */
exports.templateCategories = [{
  tag: 'bd',
  key: 'tile.heading.buildDeployTemplates'
}, {
  tag: 'btd',
  key: 'tile.heading.buildTestDeployTemplates'
}, {
  tag: 'cf',
  key: 'tile.heading.cfTemplates'
}, {
  tag: 'k',
  key: 'tile.heading.kTemplates'
}, {
  tag: 'cd',
  key: 'tile.heading.cdTemplates'
}, {
  tag: 'ca',
  key: 'tile.heading.caTemplates'
}, {
  tag: 'insights',
  key: 'tile.heading.insightsTemplates'
}, {
  tag: 'other',
  key: 'tile.heading.otherTemplates'
}];

// Toolchain names will be limited to this length
exports.maxToolchainNameLength = 63; // 63 is the route name limit in cloud foundry, and most templates derive routes from toolchain name

// how long the getting started text appears for new visitors to a toolchain, if the template
// specified any getting started help
exports.gettingStartedDuration = 7 * 24 * 60 * 60 * 1000; // 1 week

exports.gitServices = {
  bitbucketgit: "bitbucketgit",
  github: "github",
  // deprecated, but included to support older templates that may still use it
  githubconsolidated: "githubconsolidated",
  githubpublic: "githubpublic",
  github_integrated: "github_integrated",
  gitlab: "gitlab",
  hostedgit: "hostedgit"
};
exports.gitServiceIds = ["bitbucketgit", "github",
// deprecated, but included to support older templates that may still use it
"githubconsolidated", "githubpublic", "github_integrated", "gitlab", "hostedgit"];

// Ordered according to priority
exports.gitSourceProviders = ["githubconsolidated", "hostedgit", "gitlab", "bitbucketgit", "github_integrated"];
exports.fsCloudTag = "compliance:fscloud";